
import { PropsWithChildren, useState } from 'react';
import { Link } from 'react-router-dom';

const mobileMenuItems = [
  { label: 'Home', to: '/' },
  { label: 'Download', to: '/download' },
  { label: 'Features', to: '/features' },
  { label: 'About', to: '/about' },
  { label: 'Alkebulan', to: '/alkebulan' },
];

const Layout = ({ children }: PropsWithChildren<{}>) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen((open) => !open);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="layout">
      <nav className="layout-nav">
        <Link className="layout-nav-brand" to="/">
          <img
            className="layout-nav-logo"
            src="/logo.gif"
            alt="Pascaline Kids logo"
          />
          <span className="layout-nav-title">Pascaline Kids</span>
        </Link>
        <div className="layout-nav-actions">
          <Link className="nav-pill" to="/download">
            Download
          </Link>
          <Link className="nav-pill" to="/features">
            Features
          </Link>
          <Link className="nav-pill" to="/about">
            About
          </Link>
          <Link className="nav-pill" to="/alkebulan">
            Alkebulan
          </Link>
        </div>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={mobileMenuOpen}
          onClick={toggleMobileMenu}
        >
          <span className="menu-icon" aria-hidden>
            ☰
          </span>
          Menu
        </button>
        {mobileMenuOpen && (
          <div className="mobile-menu" role="menu">
            {mobileMenuItems.map((item) =>
              <Link
                className="mobile-menu-link"
                key={item.label}
                to={item.to}
                role="menuitem"
                onClick={closeMobileMenu}
              >
                {item.label}
              </Link>
            )}
          </div>
        )}
      </nav>
      <div className="layout-logo-watermark" aria-hidden="true">
        <img src="/logo.gif" alt="" />
      </div>
      <main className="layout-main">{children}</main>
    </div>
  );
};

export default Layout;
